import { render } from "./MobileLastSearches.vue?vue&type=template&id=549bfe48"
import script from "./MobileLastSearches.vue?vue&type=script&lang=js"
export * from "./MobileLastSearches.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__